export default {"src":"/_next/static/media/zapier.721d7148.svg","height":229,"width":500,"blurWidth":0,"blurHeight":0};